import { Box, Theme, Typography, useTheme } from '@mui/material';

import { ApplicationStatus } from '@/utils/constants';

function getColors(
  status: ApplicationStatus,
  isPendingApprovalAnnouncement: boolean,
  theme: Theme
) {
  if (isPendingApprovalAnnouncement)
    return {
      backgroundColor: theme.palette.warningBackground.main,
      color: theme.palette.warningText.main,
      dotColor: theme.palette.warning.main,
    };

  switch (status) {
    case ApplicationStatus.PendingRegionalReview:
    case ApplicationStatus.PendingStateReview:
    case ApplicationStatus.InRevision:
    case ApplicationStatus.PendingAdfReview:
      return {
        backgroundColor: theme.palette.warningBackground.main,
        color: theme.palette.warningText.main,
        dotColor: theme.palette.warning.main,
      };
    case ApplicationStatus.Closed:
    case ApplicationStatus.Denied:
      return {
        backgroundColor: theme.palette.errorBackground.main,
        color: theme.palette.errorText.main,
        dotColor: theme.palette.error.main,
      };
    case ApplicationStatus.ApplicationApproved:
    case ApplicationStatus.Submitted:
      return {
        backgroundColor: theme.palette.successBackground.main,
        color: theme.palette.successText.main,
        dotColor: theme.palette.success.main,
      };
    case ApplicationStatus.InProgress:
    default:
      return {
        backgroundColor: theme.palette.informationBackground.main,
        color: theme.palette.informationText.main,
        dotColor: theme.palette.info.main,
      };
  }
}

function ApplicationStatusBadge({
  status,
  isPendingApprovalAnnouncement,
  text,
}: {
  status: ApplicationStatus;
  isPendingApprovalAnnouncement: boolean;
  text: string;
}) {
  const theme = useTheme();
  const { backgroundColor, color, dotColor } = getColors(
    status,
    isPendingApprovalAnnouncement,
    theme
  );

  return (
    <Box
      sx={{
        display: 'inline-flex',
        gap: '4px',
        alignItems: 'center',
        padding: '4px 8px',
        borderRadius: '16px',
        backgroundColor: backgroundColor,
        color: color,
      }}
    >
      <Box
        sx={{
          width: '6px',
          height: '6px',
          borderRadius: '100%',
          backgroundColor: dotColor,
        }}
      ></Box>
      <Typography variant='subtitle3'>{text}</Typography>
    </Box>
  );
}

export default ApplicationStatusBadge;
